import { useMemo } from "react";
import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import Button from "componentsv2/button/Button";

import ctxViewSale from "../models/ModelSaleLineHistory";
import { layout as layoutSchedule } from "../models/ModelSchedule";

import { useContext } from "../store/useContext";

const History = ({ onChangeView }) => {
  const { context } = useContext();
  const party = context?.currentEvent?.item?.party?.id ?? null;
  const currentView = useSignal("list");
  const recordStoreId = useSignal(null);

  const view = "appointments";

  const domain = useMemo(() => {
    if (!party) return [];

    if (view === "appointments") {
      return [["party", "=", party]];
    }

    return [
      ["sale.party", "=", party],
      ["sale.state", "in", ["processing", "done"]],
    ];
  }, [view, party]);

  const _layoutSchedule = layoutSchedule();

  const ctxView = useMemo(() => {
    if (!domain.length) return null;

    return view === "appointments"
      ? { ..._layoutSchedule, domain, pagination: domain }
      : { ...ctxViewSale, domain, pagination: domain };
  }, [view, domain]);

  function handleView(action, recStoreId) {
    if (["edit", "add"].includes(action)) {
      currentView.value = "form";
      recordStoreId.value = recStoreId;
    } else {
      currentView.value = "list";
      recordStoreId.value = null;
    }
    if (onChangeView) onChangeView(action);
  }

  function handleButton(_, name) {}

  return (
    <div className="flex flex-col items-center justify-center p-4 bg-slate-50 rounded-md overflow-auto w-full h-full">
      <div className="flex flex-row justify-center-safe mb-4 space-x-6">
        <Button
          color={"slate"}
          name={"sales"}
          onClick={handleButton}
          content={"button.sales"}
        />
        <Button
          color={"slate"}
          name={"appointments"}
          onClick={handleButton}
          content={"button.appointments"}
        />
      </div>
      {ctxView && (
        <Board
          layout={ctxView}
          currentView={currentView}
          recordStoreId={recordStoreId}
          handleView={handleView}
          setView={currentView}
        />
      )}
    </div>
  );
};

export default History;
